import React from 'react'
import { ScalingContainer } from '../ContainerStyled'
import { useResize } from '../useResize'
import { BlurBox } from './blurBox/BlurBoxStyled'
import { MainProps } from './interfaces'

export default function Main({
  children,
  blur,
  modalFadeIn,
  padding,
}: MainProps) {
  const [intViewportHeight] = useResize()

  return (
    <ScalingContainer
      className='ScalingContainer'
      h={intViewportHeight}
      padding={padding}
    >
      <BlurBox blur={blur} modalFadeIn={modalFadeIn}>
        {children}
      </BlurBox>
    </ScalingContainer>
  )
}
